// extracted by mini-css-extract-plugin
export default {"popupContent":"nZ_n0","popupContent__title":"nZ_n1","popupContent__info":"nZ_oa","popupContent__buttons":"nZ_ob","popupContent_inCurtain":"nZ_oc","popupContent__smallText":"nZ_oe"};